var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome-page"},[_c('div',{staticClass:"bg-img"}),_c('div',{staticClass:"enter-act",on:{"click":_vm.enterAct}},[_vm._v("进入活动")])])}
var staticRenderFns = []

export { render, staticRenderFns }